import { PracticeContentDataFields } from '@cibo/core'
import { createContext, PropsWithChildren, useContext, useState } from 'react'
import { PracticeDrawer } from './PracticeDrawer'

export interface PracticeDrawerState {
  open: boolean
  practice?: PracticeContentDataFields
  selectInteraction:
    | false
    | {
        onClickSelect: ({ label, value }: { label: string; value: string }) => void
        currentPracticeIsSelected: boolean
      }
}

export interface PracticeDrawerContextType {
  drawerState: PracticeDrawerState
  setDrawerState: (state: PracticeDrawerState) => void
}

export const DEFAULT_VALUES = {
  drawerState: {
    open: false,
    practice: undefined,
    selectInteraction: {
      onClickSelect: () => console.log('PracticeDrawerContext onClickSelect is not defined'),
      currentPracticeIsSelected: false,
    },
  },
  setDrawerState: () => {},
}

export const PracticeDrawerContext = createContext<PracticeDrawerContextType>(DEFAULT_VALUES)
PracticeDrawerContext.displayName = 'PracticeDrawerContext'

export const usePracticeDrawer = () => useContext(PracticeDrawerContext)

export const PracticeDrawerProvider = ({ children }: PropsWithChildren) => {
  const [drawerState, setDrawerState] = useState<PracticeDrawerState>(DEFAULT_VALUES.drawerState)

  return (
    <PracticeDrawerContext.Provider
      value={{
        ...DEFAULT_VALUES,
        drawerState,
        setDrawerState,
      }}
    >
      {children}
      <PracticeDrawer
        practice={drawerState.practice}
        displaySelectInteraction={!!drawerState.selectInteraction}
        isSelected={
          !!drawerState.selectInteraction && drawerState.selectInteraction.currentPracticeIsSelected
        }
        open={drawerState.open}
        onCloseDrawer={() => setDrawerState(DEFAULT_VALUES.drawerState)}
        onClickSelect={() =>
          drawerState.practice?.fields.practiceId &&
          !!drawerState.selectInteraction &&
          drawerState.selectInteraction.onClickSelect?.({
            label: drawerState.practice?.fields.name,
            value: drawerState.practice?.fields.practiceId,
          })
        }
      />
    </PracticeDrawerContext.Provider>
  )
}
